<script lang="ts">
	import { Button } from '@Shelly/shelly-design-system';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from 'src/helpers/home_helpers';

	const updateHomeData = (type) => {
		const data = $home_data?.promotions || {};
		save_home('promotions', {
			bluPromo: {
				...data.bluPromo,
				[type]: false,
			},
		});

		home_data.set({
			...$home_data,
			promotions: {
				bluPromo: {
					...data.bluPromo,
					[type]: false,
				},
			},
		});
	};

	const removePromotions = () => {
		save_home('promotions', null);
		home_data.set({
			...$home_data,
			promotions: null,
		});
	};
</script>

<Button class="mb-s" icon="fas fa-dollar-sign" on:click={() => updateHomeData('basic')}
	>Reset Ble Promo Basic User modal</Button
>

<Button class="mb-s" icon="fas fa-sock" on:click={() => updateHomeData('premium')}
	>Reset Ble Promo PREMIUM User modal</Button
>

<Button icon="fas fa-sock" on:click={() => removePromotions()}>Remove all promotions</Button>
